import { CardData } from "./CardServices";
import { boosterData } from "./BoosterServices";
import api from "./BaseServices";

// Define the booster interface for TypeScript
export interface PostData {
  id: number;
  user_id: number;
  content: string;
  created_at: Date;
}

export interface PostWithItems extends PostData {
  cards: CardData[];
  boosters: boosterData[];
}

// API base URL (replace with your backend API base URL)
const API_URL = `${process.env.REACT_APP_API_URL}/posts`; // Modify this if your API is on a different URL

// Function to fetch all boosters with pagination (limit and offset)
export const getPosts = async (
  limit: number,
  offset: number
): Promise<PostWithItems[]> => {
  const response = await api.get(API_URL, {
    params: {
      limit,
      offset,
    },
  });
  return response.data;
};

export const createPost = async (
  content: string,
  boosters: number[],
  cards: number[]
): Promise<PostData> => {
  const response = await api.post(API_URL, {
    content,
    boosters,
    cards,
  });
  return response.data;
};

export const deletePost = async (id: number): Promise<boolean> => {
  const response = await api.delete(`${API_URL}/${id}`);
  return response.status === 200;
};
